import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=4fcb76f4&scoped=true"
import script from "../js/index.js?vue&type=script&lang=js&external"
export * from "../js/index.js?vue&type=script&lang=js&external"
import style0 from "./Index.vue?vue&type=style&index=0&id=4fcb76f4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcb76f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fcb76f4')) {
      api.createRecord('4fcb76f4', component.options)
    } else {
      api.reload('4fcb76f4', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=4fcb76f4&scoped=true", function () {
      api.rerender('4fcb76f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/auth/teacher/pages/Index.vue"
export default component.exports